module.exports = __webpack_public_path__ + "static/link-contact-71f870bb0cda9adbfcdc6a0cb85f363e.png";